import { render } from "./Characters.vue?vue&type=template&id=22b01efd&scoped=true"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import "./Characters.vue?vue&type=style&index=0&id=22b01efd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22b01efd"

export default script